import { makeStyles } from '@material-ui/core/styles'

import { getDirection } from '../../../../../localization'

const useStyles = makeStyles((theme) => ({
  rootGrid: {
    width: 375,
    [theme.breakpoints.between('sm', 'md')]: {
      width: 416
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    },
    [theme.breakpoints.between(600, 960)]: {
      width: '100vw'
    }
  },
  dayDefaultStyle: {
    width: 48,
    lineHeight: '48px',
    maxHeight: 48,
    marginBottom: 1,
    transition: 'all 0.2s linear',
    [theme.breakpoints.down('sm')]: {
      width: '14%'
    }
  },
  validDayDefaultStyle: {
    textAlign: 'center',
    fontSize: 15,
    color: theme.palette.text.primary,
    cursor: 'pointer',
    transformStyle: 'preserve-3d',

    '&:hover': {
      // borderRadius: '0 50% 50% 0',
      borderRadius: '50%',
      backgroundColor: theme.palette.grey[500]
    }
  },

  monthContainer: {
    width: '92%',
    margin: 'auto',
    textAlign: 'center',
    flexDirection: getDirection() === 'ltr' ? 'row' : 'row-reverse',
    [theme.breakpoints.down('xs')]: {
      // width: '100vw',
      // margin: '0px 15px'
    }
  },
  monthName: {
    textAlign: 'center',
    color: '#797979'
  },
  weekDayNamesGridItem: {
    height: 40
  },
  temporarySelectedDay: {
    backgroundColor: theme.palette.grey[300]
  },
  selectedStartDate: {
    backgroundColor: `${theme.palette.primary.main}!important`,
    color: `${theme.palette.primary.contrastText} !important`,
    borderRadius: '50%',
    position: 'relative',
    transformStyle: 'preserve-3d',
    '&:before': {
      transform: 'translateZ(-1px)',
      content: '""',
      width: '50%',
      height: '100%',
      position: 'absolute',
      right: 0,
      backgroundColor: theme.palette.grey[300]
    }
  },
  selectedStartDateForNonRange: {
    backgroundColor: `${theme.palette.primary.main}!important`,
    color: theme.palette.primary.contrastText,
    borderRadius: '50%',
    position: 'relative',
    transformStyle: 'preserve-3d'
  },
  selectedEndDate: {
    color: theme.palette.primary.main,
    borderRadius: '50%',
    lineHeight: '44px',
    position: 'relative',
    border: `3px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.background.default,
    transformStyle: 'preserve-3d',
    '&:before': {
      transform: 'translateZ(-1px)',
      content: '""',
      width: 'calc(50% + 6px)',
      height: 'calc(100% + 6px)',
      position: 'absolute',
      left: -3,
      top: -3,
      zIndex: -1,
      backgroundColor: theme.palette.grey[300]
    },
    '&:hover': {
      borderRadius: '50%',
      backgroundColor: theme.palette.background.default
    }
  },
  selectedEndDateAsStartDate: {
    '&:before': {
      transform: 'translateZ(-1px)',
      content: '""',
      width: 'calc(50% + 6px)',
      height: 'calc(100% + 6px)',
      position: 'absolute',
      left: -3,
      top: -3,
      zIndex: -1,
      backgroundColor: theme.palette.grey[300],
      opacity: 0
    }
  },
  inBetweenDays: {
    textAlign: 'center',
    fontSize: 15,
    cursor: 'pointer',
    backgroundColor: theme.palette.grey[300],
    transformStyle: 'preserve-3d',
    '&:before': {
      transform: 'translateZ(-1px)',
      content: '""',
      width: '50%',
      height: '100%',
      position: 'absolute',
      right: '-50%',
      backgroundColor: theme.palette.grey[300]
    },
    '&:hover': {
      borderRadius: 0
    }
  },
  disabledDay: {
    color: theme.palette.type === 'dark' ? '#797979' : '#cacccd'
  },
  holiday: {
    color: 'red'
  },
  addBorderBottomToToday: {
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    cursor: 'pointer'
  },
  one: {},
  two: {},
  three: {},
  four: {},
  five: {},
  six: {},
  seven: {}
}))
export default useStyles
